import { defineMessage } from 'react-intl';

import { getDesignationMessage, messageToString } from '@ratehub/base-ui';

import getCardOfferTypeAsString from './getCardOfferTypeAsString';


/**
 * Return a ribbon string appropriate to the card.
 * Currently used only by card details.
 * @param {(CreditCardSynopsisShape|CreditCardShape)} cardInfo FE view of credit card info
 * @param {boolean} cardInfo.isSponsored is the card sponsored?
 * @param {Object} cardInfo.giftCardOffer will be only be present when there is an offer
 * @param {boolean} [allowsSponsoredPlacements=false] should we allow 'sponsored' to appear on this card?
 * @param {import('react-intl').IntlShape} intl
 * @returns {string|undefined}
 */
function getCardRibbonMessage({
    cardInfo,
    allowsSponsoredPlacements = false,
    intl,
}) {
    const { isSponsored, giftCardOffer } = cardInfo;

    if (allowsSponsoredPlacements && isSponsored) {
        // “sponsored” has priority; use our common source for the message
        return messageToString(getDesignationMessage({ isSponsored }), intl);
    }

    return giftCardOffer
        ? intl.formatMessage(defineMessage({
            id: 'edb.cc.ribbon-message.gift-card-offer',
            defaultMessage: '{offerType} offer',
        }), {
            offerType: getCardOfferTypeAsString(giftCardOffer, intl),
        })
        : undefined;
}

export default getCardRibbonMessage;
